import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { throttleAjaxAction } from "../../EasyProjectsCommon/General";
import { apiMiddlewareActionTypes } from "../Middleware/apiMiddlewareActionTypes";
import { ApiAction, ApiActionInfo } from "./apiActions";

export type ApiActionCreator<TState = any> = ThunkAction<ApiAction, TState, void, Action>;
export type SaveActionArg<State = {}, ExtraArg = null> = (state: State, arg?: ExtraArg) => ApiActionInfo;

export type Callback<ExtraArg = any> = (
    res: any,
    dispatch: Dispatch,
    extraArg?: ExtraArg,
    getState?: () => any,
    apiActionInfo?: ApiActionInfo<any>
) => void;

export type SaveActionOptions<ExtraArg> = {
    throttle?: boolean;
    callback?: Callback<ExtraArg>;
    failCallback?: F;
};

export interface SaveActionType {
    <State>(creator: F1<State, ApiActionInfo>, options?: SaveActionOptions<null>): () => ApiActionCreator<State>;
    <State, ExtraArg>(creator: F2<State, ExtraArg, ApiActionInfo>, options?: SaveActionOptions<ExtraArg>): (
        extraArg: ExtraArg
    ) => ApiActionCreator<State>;
}

export const saveAction: SaveActionType = (
    creator: SaveActionArg,
    { throttle = true, callback = null, failCallback = null }: SaveActionOptions<any> = {}
) => {
    let dispatchApi = (action: ApiAction, dispatch: Dispatch<any>) => dispatch(action);
    if (throttle) {
        dispatchApi = throttleAjaxAction(dispatchApi);
    }

    type WrappedFunc = (extraArg: any) => ApiActionCreator;
    const result: WrappedFunc = extraArg => (dispatch, getState) => {
        const apiActionInfo = creator(getState(), extraArg);

        const result: any = dispatchApi({ ...apiActionInfo, type: apiMiddlewareActionTypes.API_CALL }, dispatch);
        if (callback && result && result.done) {
            result.done((res: any) => callback(res, dispatch, extraArg, getState, apiActionInfo));
        }
        if (failCallback && result && result.fail) {
            result.fail(failCallback);
        }

        return result;
    };

    return <any>((extraArg: any) => result(extraArg));
};
